import React, { Component } from "react";
import moment from "moment";
import API from "../../apiService.js";
import timezone from "moment/locale/id";

moment.updateLocale("id", timezone);

export default class FormPeriksaPrint extends Component {
  constructor(props) {
    super(props);
    this.state = {
      profile: ""
    };
  }
  componentDidMount() {
    this.getProfile();
  }

  getProfile = async () => {
    const res = await API.get(
      "management/profiles/read?code=" +
        JSON.parse(localStorage.getItem("userData")).puskesmas_id
    );
    if (res.code === 200) {
      this.setState({
        profile: res.data
      });
    }
  };
  render() {
    let kabupaten = JSON.parse(localStorage.getItem("puskesmasProfile")).villages.district.city.name
    let profile = JSON.parse(localStorage.getItem("puskesmasProfile"));
    moment.locale("id");

    return (
      <div>
        <table
          width="100%"
          style={{
            textAlign: "center",
            marginLeft: "2%",
            marginRight: "2%",
            marginTop: "2%"
          }}
        >
          <tr>
            <td rowSpan="4" width="10%">
              <div>
                <img
                  style={{ display: "block", height: "90Px" }}
                  alt=" placeholder"
                  src={process.env.REACT_APP_LOGO}
                />
              </div>
            </td>
            <td>
              {" "}
              <h3> {this.state.profile.report_header_2} </h3>
            </td>
          </tr>
          <tr>
            <td>
              {" "}
              <h3>{this.state.profile.report_header_1}</h3>
            </td>
          </tr>
          <tr>
            <td>
              <h3>{this.state.profile.name}</h3>
            </td>
          </tr>
          <tr>
            <td>
              {this.state.profile.address} Telp. {this.state.profile.phone}
            </td>
          </tr>
        </table>
        <hr></hr>
        <table
          width="100%"
          style={{ marginLeft: "2%", marginRight: "2%", marginBottom: "2%" }}
        >
          <tr>
            <td colSpan="6">
              <center>
                <u>
                  <b>SURAT KETERANGAN SEHAT</b>
                </u>
                <br></br>No.{" "}
                {this.props.letter ? this.props.letter.number : ""}
                <br></br>
              </center>
            </td>
          </tr>

          <tr>
            <td colSpan="6">
              <br></br>
            </td>
          </tr>
          <tr>
            <td colSpan="6">
              Yang bertanda tangan dibawah ini Dokter {profile.name}, {" "}
              {kabupaten.toLowerCase()}, dengan ini menerangkan bahwa
            </td>
          </tr>
          <tr>
            <td colSpan="2" width="30%">
              {" "}
              <a style={{ marginLeft: "10%" }}>Nama </a>
            </td>
            <td>
              {": " +
                this.props.patient.patients.name +
                " " +
                this.props.patient.patients.last_name}
            </td>
            <td></td>
            <td></td>
            <td></td>
          </tr>
          <tr>
            <td colSpan="2">
              <a style={{ marginLeft: "10%" }}>Jenis Kelamin</a>
            </td>
            <td>{": " + this.props.patient.patients.sexs.name}</td>
            <td></td>
            <td></td>
            <td></td>
          </tr>
          <tr>
            <td colSpan="2">
              <a style={{ marginLeft: "10%" }}>Tempat/tgl Lahir</a>
            </td>
            <td>
              {": " +
                this.props.patient.patients.birth_place +
                "/" +
                this.props.patient.patients.birth_date}
            </td>
            <td></td>
            <td></td>
            <td></td>
          </tr>
          <tr>
            <td colSpan="2">
              <a style={{ marginLeft: "10%" }}>Pekerjaan</a>
            </td>
            <td>{": " + this.props.patient.patients.job.name}</td>
            <td></td>
            <td></td>
            <td></td>
          </tr>
          <tr>
            <td colSpan="2">
              <a style={{ marginLeft: "10%" }}>Alamat</a>
            </td>
            <td colSpan="4">
              {": " +
                this.props.patient.villages.name +
                " " +
                this.props.patient.villages.district.name +
                " " +
                this.props.patient.villages.district.city.name}
            </td>
          </tr>
          <tr>
            <td>Berat Badan</td>

            <td>:{this.props.patient.examinations[0].weight} Kg</td>
            <td></td>
            <td>Tekanan Darah</td>
            <td colSpan="2">
              {": "}
              {this.props.patient.examinations[0].sistole}/{" "}
              {this.props.patient.examinations[0].diastole} mmHg
            </td>
          </tr>
          <tr>
            <td>Tinggi Badan</td>

            <td>: {this.props.patient.examinations[0].height} Cm</td>
            <td></td>
            <td>Golongan Darah</td>
            <td colSpan="2">
              :{" "}
              {this.props.patient.examinations[0].blood !== null
                ? this.props.patient.examinations[0].blood.name
                : ""}{" "}
            </td>
          </tr>
          <tr>
            <td colSpan="6">
              Demikian surat keterangan ini dibuat, dengan mengingat sumpah saat
              menerima jabatan, agar dapat dipergunakan sebagaimana mestinya.
            </td>
          </tr>
          <tr>
            <td colSpan="6">
              <br></br>
              <br></br>
            </td>
          </tr>
          <tr>
            <td colSpan="4"></td>
            <td colSpan="2" style={{ textAlign: "center" }}>
            {kabupaten? (kabupaten).replace('KABUPATEN ', '') : ''}, {moment(new Date()).format("DD MMMM YYYY")}
            </td>
          </tr>
          <tr>
            <td colSpan="4"></td>
            <td colSpan="2" style={{ textAlign: "center" }}>
              Dokter Pemeriksa
            </td>
          </tr>
          <tr>
            <td colSpan="6">
              <br></br>
              <br></br>
              <br></br>
              <br></br>
            </td>
          </tr>
          <tr>
            <td colSpan="4"></td>
            <td colSpan="2" style={{ textAlign: "center" }}>
              {this.props.patient.paramedic ? this.props.patient.paramedic.name : ''}
            </td>
          </tr>
          <tr>
            <td colSpan="4"></td>
            <td colSpan="2" style={{ textAlign: "center" }}>
              NIP.{this.props.patient.paramedic ? this.props.patient.paramedic.nip : ''}{" "}
            </td>
          </tr>
        </table>
      </div>
    );
  }
}
